import { render, staticRenderFns } from "./BroadcastApproved.vue?vue&type=template&id=63b825ef&scoped=true&"
import script from "./BroadcastApproved.vue?vue&type=script&lang=js&"
export * from "./BroadcastApproved.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastApproved.vue?vue&type=style&index=0&id=63b825ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b825ef",
  null
  
)

export default component.exports